/* ReviewsSkeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { AppListing2LineSkeleton, Stripe } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_ID } from '../../../../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _6 = "@media not all and (min-width:64rem){._3wvk1jfw{margin-top:var(--ds-space-500,40px)}}";
const _5 = "._19pkoahv{margin-top:var(--ds-space-600,3pc)}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._4t3i1wto{height:3rem}";
const _2 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const LoadMoreSkeletonContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _4t3i1wto _1e0c1txw _19pkoahv _3wvk1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LoadMoreSkeletonContainer.displayName = 'LoadMoreSkeletonContainer';
}
export const ReviewsSkeleton = _ref2 => {
  let {
    sorting = false
  } = _ref2;
  if (sorting) {
    return /*#__PURE__*/_jsx("div", {
      "data-testid": TEST_ID.REVIEWS_TAB_LOADING,
      children: [...new Array(5)].map((_, index) => {
        return /*#__PURE__*/_jsx(Stripe, {
          height: "140px",
          marginTop: "var(--ds-space-200, 16px)",
          marginBottom: "var(--ds-space-400, 32px)"
        }, index);
      })
    });
  }
  return /*#__PURE__*/_jsx(AppListing2LineSkeleton, {
    testId: TEST_ID.REVIEWS_TAB_LOADING
  });
};
export const ReviewsLoadMoreSkeleton = () => {
  return /*#__PURE__*/_jsxs(LoadMoreSkeletonContainer, {
    "data-testid": TEST_ID.REVIEWS_TAB_LOAD_MORE_LOADING,
    children: [/*#__PURE__*/_jsx(Stripe, {
      width: "2rem",
      height: "2rem",
      borderRadius: "50%"
    }), /*#__PURE__*/_jsx(Stripe, {
      width: "36%",
      height: "2rem",
      borderRadius: "7px"
    })]
  });
};